class SwiperElement extends HTMLElement {
    constructor(){
        super();
        this.swiperEle = this.querySelector('.swiper');
        this.enableDesktop = this.dataset.desktop != "false" ;
        this.navigation = this.dataset.navigation ? JSON.parse(`${this.dataset.navigation}`) : {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        };
    }
    connectedCallback() {
        if(window.innerWidth < 768 || this.enableDesktop){
            this.swiper = new Swiper(this.swiperEle, {
                slidesPerView: 'auto',
                // Navigation arrows
                navigation: this.navigation,
    
                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                spaceBetween: 16,
            });
        }
    }
}
customElements.define('swiper-element', SwiperElement);